<template>
  <b-modal v-model="show" centered :title="'Neuer '+aufnName"
  >
    <b-row class="justify-content-md-center">
      <b-col>
        <label for="name">Name</label>
        <b-form-input id="name" type="text"
                      v-model="aufn.name"
                      class="mb-2 text-black"
                      maxlength="50"
                      @focusin="error = false"
                      :state="error ? false : null"
        ></b-form-input>
        <b-form-text style="text-align: right" v-if="!error">{{aufn.name.length}}/50</b-form-text>
        <b-form-text style="text-align: right; color: red !important;" v-else>Der Name darf nicht leer sein.</b-form-text>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "CreateAufnDialog",
  props:{
    aufnName: {
      type: String,
      default: () => 'Kunde'
    },
  },
  data() {
    return {
      show: false,
      aufn: {
        name: '',
      },
      error: false,
    }
  },
  methods: {
    showModal() {
      this.aufn = {
        name: '',
      };
      this.error = false;
      this.show = true;
    },
    getReturnData() {
      return this.aufn;
    },
    async onSave() {
      this.aufn.name = this.aufn.name.trim();
      if (!this.aufn.name) {
        this.error = true;
        return;
      }
      let data = this.getReturnData();
      this.$emit('create-aufn', data);
      this.show = false;
    },

    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
</style>
